<script context="module">
  /**
   * @author M.G.
   */
  import { External, M } from "../../external";

  export function sendTestEmail(emailData){
    External.Tools.makeWebsiteRequest({
      action: "sendIndividualEmailTest",
      method: "post",
      data: {
        data: JSON.stringify(emailData)
      },
      onOk: () => {
        External.Tools.showAutohideMessage(5, External.userEmail + ' - ' + M.TEST_MESSAGE_SENT);
      }
    });
  }

  export function showEmailPreview(emailData) {
    let options = {
      buttonText: M.SHOW_IN_NEW_TAB,
      onButtonAction: (pageUrl) => {
        window.open(pageUrl, "_blank").focus();
      },
      iframeLoader: (iframe) => {
        const iframeName = iframe.attr('name');
        const form = External.$('<form>', {
          target: iframeName,
          method: 'POST',
          action: '/me/email'
        });
        const input = External.$('<input>', {
          type: 'hidden',
          name: 'content',
          value: emailData
        });
        form.append(input);
        External.$('body').append(form);
        form.submit();
        form.remove();
      }
    };

    External.Tools.showWebsitePreviewPopup(options);
  }

</script>

<script>
  import Design from "../../Campaign/Design.svelte";
  import { REGULAR } from "../../Campaign/static";
  import { ignore } from "../../Common/tools";

  export let data, onSaveEmail = ignore, onClose = ignore, onContentChange = ignore;

  let designer, moreBtn, tab = "design";

  data.type = REGULAR;

  export function get(){
    return data;
  }

  function chooseNewTemplate() {
    External.Tools.prompt(M.DISCARD_DESIGN, M.DISCARD_DESIGN_DESC, () => {
      data.content = null;
    });
  }

  function saveTemplate() {
    External.Tools.promptForInput(M.TEMPLATE_NAME, M.TEMPLATE_NAME, "", (value) => {
      designer.saveAsTemplate(value);
    });
  }

  async function saveEmail(closePopup){
    if(await designer.verify()){
      onSaveEmail(data, closePopup);
    }
  }

  const MORE_OPTIONS = [
    { text: M.SAVE_AS_TEMPLATE,         icon: "fa-save",  tag: "save"     },
    { text: M.SELECT_ANOTHER_TEMPLATE,  icon: "fa-file",  tag: "template" },
    { text: M.PREVIEW,                  icon: "fa-eye",   tag: "preview"  },
    { text: M.SEND_TEST_EMAIL,          icon: "fa-at",    tag: "test"     }
  ];


  function showMoreOptions(){
    const target = External.$(moreBtn);

    External.Tools.showTooltipOptions(target, MORE_OPTIONS, async (target, idx, text, tag) => {
      if (tag === "template") {
        chooseNewTemplate();
      } else if (tag === "save") {
        saveTemplate();
      } else if (tag === "preview") {
        await saveEmail(false);
        showEmailPreview(JSON.stringify(data.content));
      } else if (tag === "test") {
        sendTestEmail(data);
      }
    });
  }
</script>

<div class="email-builder-lane flex flex-row align-center flex-none" style="padding: 5px 40px;">
  <div class="flex align-center flex-1">
    <a class="light-gray-button middle-button circle-effect mr-5" on:click={onClose}>← {M.PREVIOUS}</a>
  </div>
  <div class="flex align-center flex-1 justify-flex-end">
    {#if tab === "design" && data.content !== null}
      <a class="floating-button middle-button blue circle-effect button-with-icon mr-5" on:click={showMoreOptions} bind:this={moreBtn}>
        <span class="material-icons">more_vert</span>{M.MORE}
      </a>
    {/if}
    {#if data.content !== null}
      <a class="middle-button light-gray-button circle-effect mr-5" on:click={saveEmail}>
        <span class="material-icons-outlined">done</span>{M.OK}
      </a>
    {/if}
  </div>
</div>
<Design bind:data bind:this={designer} onChange={onContentChange} />
